import { cn } from "@/lib/utils";

// Reusable empty / placeholder state with a clear explanation.
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  tone = "dark",
  className = "",
  testId = "empty-state",
  children,
}) => {
  const isLight = tone === "light";
  return (
    <div
      className={cn(
        "rounded-2xl border border-dashed p-8 md:p-10 text-center",
        isLight
          ? "border-legacy-charcoal/20 bg-legacy-charcoal/[0.03]"
          : "border-white/15 bg-white/[0.03]",
        className
      )}
      data-testid={testId}
    >
      {Icon && (
        <Icon
          className={cn(
            "h-8 w-8 mx-auto mb-4",
            isLight ? "text-legacy-gold" : "text-legacy-mint"
          )}
          aria-hidden="true"
        />
      )}
      {title && (
        <h3
          className={cn(
            "font-heading text-2xl mb-2",
            isLight ? "text-legacy-charcoal" : "text-white"
          )}
        >
          {title}
        </h3>
      )}
      {description && (
        <p
          className={cn(
            "text-sm md:text-base leading-relaxed max-w-xl mx-auto",
            isLight ? "text-legacy-charcoal/70" : "text-white/65"
          )}
        >
          {description}
        </p>
      )}
      {children && <div className="mt-6">{children}</div>}
    </div>
  );
};

// Integration placeholder card (e.g. Vagaro embed slot).
export const IntegrationPlaceholder = ({
  title = "Vagaro Booking Integration",
  description,
  tone = "dark",
  testId = "integration-placeholder",
}) => {
  const isLight = tone === "light";
  return (
    <div
      className={cn(
        "rounded-2xl border p-6 md:p-8 flex items-start gap-4",
        isLight
          ? "border-legacy-charcoal/15 bg-legacy-ivory"
          : "border-legacy-mint/20 bg-legacy-mint/[0.05]"
      )}
      data-testid={testId}
    >
      <span
        className="mt-1 h-2.5 w-2.5 rounded-full bg-legacy-gold shrink-0"
        aria-hidden="true"
      />
      <div>
        <p
          className={cn(
            "font-semibold",
            isLight ? "text-legacy-charcoal" : "text-white"
          )}
        >
          {title}
        </p>
        <p
          className={cn(
            "text-sm mt-1 leading-relaxed",
            isLight ? "text-legacy-charcoal/70" : "text-white/65"
          )}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
